import { ChangeDetectionStrategy, Component } from '@angular/core';

import { Route, RouterLinkPipe } from '@web/common';
import { SvgIcon } from '@web/shared/ui';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-header-sign-in-link',
  imports: [RouterLinkPipe, RouterLink],
  templateUrl: './header-sign-in-link.component.html',
  styleUrl: './header-sign-in-link.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderSignInLinkComponent {
  protected readonly Route = Route;
  protected readonly SvgIcon = SvgIcon;
}
